import zod from 'zod';
import { zodLimit, zodPage } from './helpers';

export const ClonedPlateSchemas = {
    CloneSuspicions: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    ClonedPlates: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
};
